module.exports = __webpack_public_path__ + "img/KM-360A_12.7bb703e7.jpg";